import {
  PUSH_NOTIFICATION_REQUEST,
  TOGGLE_PUSH_NOTIFICATION,
  UPDATE_PUSH_NOTIFICATION,
} from './constants'

export const getPushNotification = () => ({
  type: PUSH_NOTIFICATION_REQUEST.INITIATE,
})
export const getPushNotificationSuccess = (data) => ({
  type: PUSH_NOTIFICATION_REQUEST.SUCCESS,
  payload: { data },
})
export const getPushNotificationError = (error) => ({
  type: PUSH_NOTIFICATION_REQUEST.ERROR,
  error,
})
export const getPushNotificationCancel = () => ({
  type: PUSH_NOTIFICATION_REQUEST.CANCEL,
})

const updatePushNotification = () => ({
  type: UPDATE_PUSH_NOTIFICATION.INITIATE,
})
export const updatePushNotificationSuccess = (data) => ({
  type: UPDATE_PUSH_NOTIFICATION.SUCCESS,
  payload: { data },
})
export const updatePushNotificationError = (error) => ({
  type: UPDATE_PUSH_NOTIFICATION.ERROR,
  error,
})
const updatePushNotificationCancel = () => ({
  type: UPDATE_PUSH_NOTIFICATION.CANCEL,
})

const togglePushNotification = (name, state) => ({
  type: TOGGLE_PUSH_NOTIFICATION,
  payload: { name, state },
})

export default {
  // to props
  updatePushNotification,
  updatePushNotificationCancel,
  togglePushNotification,
}
